import { CoPlainText } from "./coPlainText.js";

export class CoRichText extends CoPlainText {}
